<template>
  <div class="edit-detailed-top">
    <!-- 返回 -->
    <div class="back-top">
      <a
        class="fs-blue"
        @click="goBack"
      >返回</a><i>/</i><span>编辑清单</span>
    </div>
    <!-- 修改清单名称 -->
    <div class="detailed-name clearfix">
      <span
        v-show="!showEdit"
        class="name fl"
      >{{ name }}</span>
      <i
        v-show="!showEdit"
        class="iconfont iconicon-test66 fl"
        @click="showEdit = !showEdit"
      />
      <a-form
        v-show="showEdit"
        ref="form"
        :form="form"
        class="fl"
        @submit="handleSubmit"
      >
        <max-length-input
          :value="name"
          :required="true"
          label=""
          fieldkey="name"
          placeholder="请输入清单名称"
          class="fl"
          @change="handleInput"
        />
        <a-button
          type="primary"
          html-type="submit"
        >
          确定
        </a-button>
        <a-button @click="handleCancel">
          取消
        </a-button>
      </a-form>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import MaxLengthInput from '@/components/pc/MaxLengthInput'

export default {
  components: {
    MaxLengthInput
  },

  props: {
    contactid: {
      type: [String, Number],
      default: ''
    },
    contactName: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      form: this.$form.createForm(this),
      name: '',
      oldName: '',
      showEdit: false
    }
  },

  watch: {
    contactName (val, oldVal) {
      this.name = val
      this.oldName = val
    }
  },

  methods: {
    ...mapActions('edm/detailedList', ['editContact']),
    goBack () {
      this.$router.push({
        name: 'DetailedList'
      })
    },
    handleInput (val) {
      this.name = val
    },
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields(async (err, values) => {
        if (!err) {
          let params = {
            name: this.name,
            id: this.contactid
          }

          let chain = await this.editContact(params)
          chain.onSuccess(res => {
            this.showEdit = false
            this.$emit('setContactName', this.name)
          })
        }
      })
    },
    handleCancel () {
      this.showEdit = false
      this.name = this.oldName
      this.$emit('setContactName', this.oldName)
    }
  }
}
</script>

<style scoped lang="scss">
.back-top {
  margin-bottom: 24px;
  color: #B3B3B3;
  i {
    margin: 0 6px;
  }
}
.detailed-name {
  margin-bottom: 8px;
  .name {
    height: 32px;
    line-height: 32px;
    margin-right: 4px;
    font-size: 18px;
    font-weight: bold;
  }
  .iconfont {
    height: 32px;
    line-height: 32px;
    margin-right: 16px;
    color: #ccc;
  }
  .input-limit {
    margin-right: 16px;
  }
  .ant-form-item {
    margin-bottom: 0;
  }
}
</style>
